import { render, staticRenderFns } from "./EditEventDialog.vue?vue&type=template&id=5f0fa45f&"
import script from "./EditEventDialog.vue?vue&type=script&lang=js&"
export * from "./EditEventDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditEventDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports